/* SG wishlist. No dependencies. Loaded from snippets/sg-head.liquid when
   Theme settings > Wishlist is on.
   - The list is product handles in localStorage, under the same key and
     format the previous theme used ('shopify-wishlist', comma-separated),
     so shoppers keep what they saved before.
   - [data-sg-wishlist="handle"] buttons toggle a product (aria-pressed).
   - [data-sg-wishlist-count] shows how many are saved (header).
   - [data-sg-wishlist-page] fills its grid with one card per product from
     /products/<handle>?section_id=sg-wishlist-card (Section Rendering API);
     products that no longer exist (no card comes back) are dropped from the list.
   Exposes window.SGWishlist = { get, has, toggle }. */
(function () {
  'use strict';

  var KEY = 'shopify-wishlist';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function get() {
    try {
      var raw = localStorage.getItem(KEY);
      return raw ? raw.split(',').filter(Boolean) : [];
    } catch (e) { return []; }
  }

  function set(list) {
    try { localStorage.setItem(KEY, list.join(',')); } catch (e) {}
    sync();
  }

  function has(handle) { return get().indexOf(handle) > -1; }

  function toggle(handle) {
    var list = get();
    var i = list.indexOf(handle);
    if (i > -1) list.splice(i, 1); else list.push(handle);
    set(list);
    return i === -1;
  }

  function paint(btn) {
    var on = has(btn.getAttribute('data-sg-wishlist'));
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    var label = btn.getAttribute(on ? 'data-label-on' : 'data-label-off');
    if (label) btn.setAttribute('aria-label', label);
  }

  function sync() {
    document.querySelectorAll('[data-sg-wishlist]').forEach(paint);
    var n = get().length;
    document.querySelectorAll('[data-sg-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
    document.querySelectorAll('[data-sg-wishlist-link]').forEach(function (el) {
      el.setAttribute('aria-label', n ? 'Wishlist, ' + n + (n === 1 ? ' item' : ' items') : 'Wishlist');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-sg-wishlist]');
    if (!btn) return;
    e.preventDefault();
    var added = toggle(btn.getAttribute('data-sg-wishlist'));
    btn.classList.remove('is-pop');
    void btn.offsetWidth;
    if (added) btn.classList.add('is-pop');
    if (window.SG && SG.toast) {
      var link = document.querySelector('[data-sg-wishlist-link]');
      var onPage = !!document.querySelector('[data-sg-wishlist-page]');
      SG.toast(added ? 'Saved to your wishlist' : 'Removed from your wishlist', false,
        link && !onPage ? { label: 'View wishlist', href: link.getAttribute('href') } : false);
    }

    // On the wishlist page, removing a product takes its card away
    var item = !added && btn.closest('[data-sg-wishlist-item]');
    if (item) {
      item.classList.add('is-removing');
      setTimeout(function () { item.remove(); pageState(); }, 250);
    }
  });

  // Other tabs
  window.addEventListener('storage', function (e) { if (e.key === KEY) sync(); });

  /* ---------- Wishlist page ---------- */
  var page = document.querySelector('[data-sg-wishlist-page]');
  var grid = page && page.querySelector('[data-sg-wishlist-grid]');
  var empty = page && page.querySelector('[data-sg-wishlist-empty]');
  var summary = page && page.querySelector('[data-sg-wishlist-summary]');

  function pageState() {
    if (!grid) return;
    var n = grid.children.length;
    if (empty) empty.hidden = n > 0;
    if (summary) summary.textContent = n ? n + (n === 1 ? ' item saved' : ' items saved') : '';
  }

  function fillPage() {
    var handles = get();
    if (!handles.length) { grid.setAttribute('aria-busy', 'false'); pageState(); return; }
    var missing = [];
    Promise.all(handles.map(function (handle) {
      return fetch(root + 'products/' + encodeURIComponent(handle) + '?section_id=sg-wishlist-card')
        .then(function (r) {
          if (r.status === 404) { missing.push(handle); return ''; }
          if (!r.ok) return '';
          // Shopify answers 200 with an empty section for a product that no
          // longer exists (or isn't published), so check for the card itself
          return r.text().then(function (html) {
            if (html.indexOf('data-sg-wishlist-item') === -1) missing.push(handle);
            return html;
          });
        })
        .catch(function () { return ''; });
    })).then(function (cards) {
      var tmp = document.createElement('div');
      tmp.innerHTML = cards.join('');
      tmp.querySelectorAll('[data-sg-wishlist-item]').forEach(function (li) { grid.appendChild(li); });
      if (missing.length) set(get().filter(function (h) { return missing.indexOf(h) === -1; }));
      grid.setAttribute('aria-busy', 'false');
      sync();
      pageState();
      if (window.SG && SG.init) SG.init(grid);
    });
  }

  window.SGWishlist = { get: get, has: has, toggle: toggle };

  function init() {
    sync();
    if (grid) fillPage();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
